import * as THREE from "three";
import {DiskInternet} from "../Shapes/DiskInternet";
import {Line} from "../Shapes/Line";
import {RoutersManager} from "./Router/ManagerGeneralRouter";
import {RouterNetworkTree} from "../../../../../../services/back/infrastructure-schema.service";
import {RouterNodeOutput} from "../System/GlobalSizing";

export function Shapes(
	scene: THREE.Scene,
	data: Array<RouterNetworkTree>,
	dataguide: RouterNodeOutput[]
) {

	// Internet
	DiskInternet(scene, 0, -18);
	Line(scene,0, -18, 0, -13);

	RoutersManager(scene, 0, -13, data, dataguide);
}
